import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist';
import { selectVoucherTypes, selectVoucherTypesIsLoading, } from '@debbie/cortex/dist/economy/selectors';
import { selectTenantId } from '@debbie/cortex/dist/selectedOwners/selectors';
import Back from '../Back';
import List from '../List';
import Loading from '../Loading';
const VoucherTypeSelector = (props) => {
    const allVoucherTypes = useSelector(selectVoucherTypes);
    const allVoucherTypesIsLoading = useSelector(selectVoucherTypesIsLoading);
    const tenantId = useSelector(selectTenantId);
    const lang = useSelector((s) => s.lang);
    const [category, setCategory] = useState(null);
    useEffect(() => {
        if (!allVoucherTypes && tenantId && !allVoucherTypesIsLoading) {
            c.economy.getVoucherTypes();
        }
    }, []);
    const voucherTypes = (allVoucherTypes || [])
        .concat([])
        .sort((a, b) => a.order - b.order);
    if (!allVoucherTypes) {
        return React.createElement(Loading, { width: "32px" });
    }
    return category ? (React.createElement(React.Fragment, null,
        React.createElement(Back, { onClick: () => {
                setCategory(null);
            }, header: lang.economyCategories[category] }),
        React.createElement(List, { items: (() => {
                const categoryVouchers = voucherTypes.filter((type) => {
                    const excludeVoucherType = (props.voucherTypeFilter || []).includes(type.voucherTypeId);
                    return type.category === category && !excludeVoucherType;
                });
                const typeMap = props.typeMap[category];
                if (typeMap != null) {
                    return typeMap(categoryVouchers).map((type) => ({
                        key: type.type.voucherTypeId,
                        label: type.label,
                        returnItem: type.type,
                    }));
                }
                return categoryVouchers.map((type) => ({
                    key: type.voucherTypeId,
                    label: lang.economyVoucherTypeLabels[type.voucherTypeId] || type.label,
                    returnItem: type,
                }));
            })(), onSelect: (type) => {
                props.onSelect(type);
                setTimeout(() => setCategory(null), 500);
            } }))) : (React.createElement(List, { items: Array.from(new Set(voucherTypes
            .map((type) => type.category)
            .filter((category) => Array.isArray(props.categoryFilter)
            ? props.categoryFilter.indexOf(category) !=
                -1
            : true)), (category) => ({
            key: category,
            label: lang.economyCategories[category],
            returnItem: category,
        })), onSelect: (category) => {
            setCategory(category);
        } }));
};
export default VoucherTypeSelector;
//# sourceMappingURL=VoucherTypeSelector.js.map